import { Button, Text, mergeClasses } from "@fluentui/react-components";
import { Flex } from "../flex";
import { ContactLabelProps } from "./types";
import { useStyle } from "./style";
import { Dismiss16Regular } from "@fluentui/react-icons";

export const ContactLabel = (props: ContactLabelProps) => {
	const { text, onButtonClick, appearance, classesName, disabled, buttonAriaLabel } =
		props;
	const classes = useStyle();

	return (
		<Flex
			className={mergeClasses(
				classes.root,
				!!appearance ? classes[appearance] : undefined,
				classesName?.root
			)}
			vAlign="center"
		>
			<Text size={200} wrap={false} truncate title={text} children={text} />
			<Button
				disabled={disabled ?? false}
				onClick={onButtonClick}
				appearance="transparent"
				aria-label={buttonAriaLabel ?? text}
				icon={<Dismiss16Regular />}
			/>
		</Flex>
	);
};
